import {KTCard} from '../../../_metronic/helpers'
import {useLazyQuery} from '@apollo/client'
import {VERIFY_LIVE_AGENT} from '../../../utils/GraphQLAPI'
import {alert} from '../../../utils/helper'

type pinNumberProps = {
  setIsVerified: any
  userName: string
  pincode: any
  setPincode: any
  setIndex: any
  setDetails:any
  getCustomerInfo:any
  setCanEdit:any
}

const PinNumber = ({
  setIsVerified,
  userName,
  pincode,
  setPincode,
  setIndex,
  setDetails,
  getCustomerInfo,
  setCanEdit
}: pinNumberProps) => {
  const [verifyLiveagent] = useLazyQuery(VERIFY_LIVE_AGENT, {
    onCompleted: (data) => {
      setDetails({
        clientName:data?.verifyLiveAgentCustomerByPin.clientName,
      })
      if(data?.verifyLiveAgentCustomerByPin.enableCustomerDetails){
        setCanEdit(data?.verifyLiveAgentCustomerByPin.enableCustomerDetails)
      }
      
      setIndex(1)
      setIsVerified(true)
      getCustomerInfo({
        variables:{
          pincode
        }
      })
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: 'network-only',
  })
  return (
    <KTCard className='mt-5 p-5'>
      <div className='card card-custom'>
        <div className='card-header card-body flex-column justify-content-center  align-items-center pb-0 border-0'>
          <h4 className='fs-3'>
            Thank you for calling TPV solutions. My name is {userName}, please provide your pin
            number
          </h4>
          <h4 className='fs-3'>
          Gracias por llamar a TPV Solutions. Mi nombre es {userName}, por favor proporcione su número PIN.
          </h4>
          <div className='d-flex flex-column my-5'>
            <label className={`d-flex align-items-center mb-2`}>
              <div className='fs-6 fw-semibold lh-23px'>Pin Number</div>
            </label>
            <input
              id='pinnumber'
              type='number'
              className='form-control form-control-lg form-control-solid'
              value={pincode}
              onChange={(e) => {
                if(e.target.value.length < 6){
                  setPincode(e.target.value)
                }
              }}
              name='pin number'
              placeholder='Enter pin number'
            />
          </div>
          <button
            className='btn btn-primary'
            onClick={() =>
              verifyLiveagent({
                variables: {
                  pincode,
                },
              })

            }
            disabled={!Boolean(pincode)}
          >
            Submit
          </button>
        </div>
      </div>
    </KTCard>
  )
}
export default PinNumber
